module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am635-ac5200f68ce4cfdc3dcabff60befcedf.jpg";